// extracted by mini-css-extract-plugin
export default {"root":"fwt9Hvtu","banner":"rVQ04ezy","title":"lioy+Z+Q","decorator":"_8GrEtymI"};